<!-- eslint-disable vue/multi-word-component-names -->
<script>
  export default {
    name: 'app-card',
  };
</script>
<template>
  <div>
    <slot name="header"></slot>
    <slot name="body"></slot>
    <slot name="action"></slot>
  </div>
</template>
